export const handleUnsafeOptionalChaining = <T extends object>(value: T | null | undefined): Partial<T> => value || {};
